module.exports = __webpack_public_path__ + "media/images/front/banner_digital_dental_academy-98b9d8b4b7e8be3013a4bca2f352f735.png";